import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

interface CategoryCardWrapperProps {
  $isExpanded: boolean;
}

export const CategoryCardWrapper = styled(Box)<CategoryCardWrapperProps>`
  flex-shrink: 0;
  transition: box-shadow 0.15s ease;
  box-shadow: inset 0 0 0 ${({ $isExpanded }) => ($isExpanded ? '2px' : '1px')}
    ${({ theme, $isExpanded }) => ($isExpanded ? theme.colors.border1 : theme.colors.border2)};

  &:hover {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.border1};
  }
`;
